import script from "./TeamRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./TeamRow.vue?vue&type=script&setup=true&lang=ts"

import "./TeamRow.vue?vue&type=style&index=0&id=53737b7f&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53737b7f"]])

export default __exports__